import React from 'react';
import './imageGrid.css';

const ImageGrid = ({ images }) => {
    return (
        <div className="image-grid">
            <div className='container'>
                <div className='row'>
                    {images.map((image, index) => (
                        <div key={index} className="col-md-4 image-grid-container">
                            <img src={image.src} alt={image.alt || `Image ${index + 1}`} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ImageGrid;
